import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
  Grid,
  Checkbox,
  ListItemText
 } from '@mui/material';

const useStyles = makeStyles({
  searchContainer: {
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 20,
    marginTop: 20,
    padding: 20,
    borderRadius: 7,
    textAlign: "left",
    border: "1px solid #1876d2",
  },
  header: {
    margin: "0 0 10px 0",
  },
  searchButtonWrapper: {
    textAlign: "right",
  },
  clearButton: {
    marginRight: "10px!important"
  }
});


const AdvancedSearch = ({ADVANCE_SEARCH_FIELDS, REPORT_DOWNLOADS, onSubmit, onReport}) => {
  const classes = useStyles();

  const defaultValues = () => {
    let values = {}
    ADVANCE_SEARCH_FIELDS.forEach((field) => {
      values[field.name] = field.default_value
    })
    return values
  }

  const [searchParams, setSearchParams] = useState(defaultValues());

  const cleanParams = Object.fromEntries(
    Object.entries(searchParams).filter(([key, value]) => {
      if (Array.isArray(value)) {
        return value.length > 0; // Exclude empty arrays
      }
      return value && value.trim() !== ''; // Exclude empty or blank strings
    })
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(cleanParams);
  };

  const handleReport = (e, type) => {
    e.preventDefault();
    onReport({...cleanParams, report_type: type});
  };

  const handleClear = () => {
    setSearchParams(defaultValues());
    onSubmit({})
  }
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchParams((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeMultiple = (e) => {
    const { name, value } = e.target;
    setSearchParams((prev) => ({
      ...prev,
      [name]: typeof value === 'string' ? value.split(',') : value,
    }));
  };

  const renderMultipleValue = (options, selected) => {
    return selected.map((value) => {
      return options.find((role) => role.value === value).label;
    }).join(', ');
  }

  const textField = (field, label) => {
    return(
      <TextField
        fullWidth
        label={label}
        name={field}
        variant="outlined"
        value={searchParams[field]}
        onChange={handleChange}
      />
    )
  }

  const dropdownField = (field, label, options) => {
    return(
      <FormControl fullWidth variant="outlined">
        <InputLabel>{label}</InputLabel>
        <Select
          label={label}
          name={field}
          multiple
          value={searchParams[field]}
          renderValue={(selected) => renderMultipleValue(options, selected)}
          onChange={handleChangeMultiple}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              <Checkbox checked={searchParams[field].indexOf(option.value) > -1} />
              <ListItemText primary={option.label} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )
  }

  const getComponent = (props, index) => {
    return(
      <Grid item {...props['grid']} key={`advance_search_grid_${index}`}>
        {props['type'] == 'text' && textField(props['name'], props['label'])}
        {props['type'] == 'dropdown' && dropdownField(props['name'], props['label'], props['options'])}
      </Grid>
    )
  }

  return (
    <div className={classes.searchContainer}>
      <h5 className={classes.header}>Advance Search</h5>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          {ADVANCE_SEARCH_FIELDS != undefined && ADVANCE_SEARCH_FIELDS.map((field, i) => getComponent(field, i))}
          <Grid item xs={12} sm={6}>
            {REPORT_DOWNLOADS != undefined && REPORT_DOWNLOADS.map((download) => {
              return(
                <Button variant="contained" color="primary" onClick={(e) => handleReport(e, download.report_type)}>
                  {download.name}
                </Button>
              )
            })}
          </Grid>
          <Grid item xs={12} sm={6} className={classes.searchButtonWrapper}>
            <Button className={classes.clearButton} onClick={handleClear}>
              Clear
            </Button>
            <Button variant="contained" color="primary" type="submit">
              Search
            </Button>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default AdvancedSearch;
